import type { User } from "../../models/User";
import type { WPProductConfig } from "../../models/WPProductConfig";
import type { WPTest } from "../../models/WPTest";
import { configRefs } from "../constants/config";
import { DAYS_TO_MS, HOURS_TO_MS } from "../constants/time";
import { createCache } from "../createCache";

import type { ApiClientOptions } from "./typings/ApiClientOptions";
import type { ApiRequestInterceptor } from "./typings/ApiRequestInterceptor";
import { fetchRequest, NOT_FOUND_ERROR } from "./utils/fetchRequest";

const HARDCODED_PORTAL_ID = "7dd9f657-596f-4956-9245-644e3db4ec0c";

export function makeFetchStudentCompletedTests(
  requestInterceptor: ApiRequestInterceptor,
  options: ApiClientOptions,
) {
  const cache = createCache<WPTest[]>({
    timeToLiveMs: 1 * HOURS_TO_MS,
    timeToEvictMs: 1 * DAYS_TO_MS,
    ...options,
  });

  return (user: User, product: WPProductConfig) => {
    return cache(
      `u:${user.id}-i:${user.institutionId}-p:${product.id}`,
      async () => {
        try {
          const response = await fetchRequest<WPTest[]>(
            requestInterceptor(
              `${await configRefs.apis.webproever.get()}/${HARDCODED_PORTAL_ID}/products/${product.id}/tests/${user.institutionId}/${user.id}/completed`,
            ),
          );

          return response;
        } catch (err) {
          if (err === NOT_FOUND_ERROR) {
            return [];
          } else {
            throw err;
          }
        }
      },
    );
  };
}
